import printerIcon from 'assets/icon/printer.svg';
import { Button, SwitchBtn } from 'components/FormTitleBar';
import React from 'react';
import SVG from 'react-inlinesvg';

type PrintButtonProps = {
  disabled?: boolean;
  handlePrint?: () => void;
};

const PrintButton: React.VFC<PrintButtonProps> = ({ handlePrint, disabled = false }) => {
  return (
    <SwitchBtn showSubmit={disabled} style={{ cursor: disabled ? 'default' : 'pointer' }}>
      {!disabled && (
        <Button data-test="printer-icon" onClick={handlePrint}>
          <SVG src={printerIcon} />
        </Button>
      )}
    </SwitchBtn>
  );
};

export default PrintButton;
